// Inline Vimeo/YouTube facade (mm-embed.liquid).
// 1) Click a [data-mm-embed] play button -> load the autoplaying iframe in
//    place, filling the media box.
// 2) Auto-thumbnail: when the media box has NO image of its own (merchant
//    didn't upload one), fetch the video's official thumbnail from
//    YouTube/Vimeo and show it behind the play button - the same behaviour
//    Shopify gives hosted videos.
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mm-embed]');
    if (!btn) return;
    e.preventDefault();
    var src = btn.getAttribute('data-mm-embed');
    var host = btn.parentNode;
    if (!host || host.querySelector('.mm-embed__iframe')) return;
    var f = document.createElement('iframe');
    f.className = 'mm-embed__iframe';
    f.setAttribute('src', src);
    f.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('title', 'Video player');
    host.appendChild(f);
    host.classList.add('mm-embed-active');
    btn.setAttribute('hidden', '');
  });

  function insertThumb(host, btn, src, fallback) {
    var img = document.createElement('img');
    img.className = 'mm-embed__thumb';
    img.alt = '';
    img.loading = 'lazy';
    img.onerror = function () {
      if (fallback && img.src.indexOf(fallback) === -1) img.src = fallback;
      else img.remove();
    };
    img.src = src;
    host.insertBefore(img, btn);
  }

  function autoThumb(btn) {
    if (btn.hasAttribute('data-mm-thumbed')) return;
    btn.setAttribute('data-mm-thumbed', '');
    var host = btn.parentNode;
    if (!host) return;
    // A real image already fills this media box (uploaded still / video
    // poster / product image) - don't paint over the merchant's choice.
    // Direct children only: nested images (e.g. a floater avatar) don't count.
    if (host.querySelector(':scope > img:not(.mm-embed__thumb)')) return;
    var src = btn.getAttribute('data-mm-embed') || '';

    // YouTube: thumbnails live at a predictable URL. Try the HD frame first,
    // fall back to the always-available one.
    var yt = src.match(/youtube\.com\/embed\/([\w-]+)/);
    if (yt) {
      insertThumb(host, btn,
        'https://i.ytimg.com/vi/' + yt[1] + '/maxresdefault.jpg',
        'https://i.ytimg.com/vi/' + yt[1] + '/hqdefault.jpg');
      return;
    }

    // Vimeo: ask Vimeo's public oEmbed API for the thumbnail (works for
    // unlisted videos too - the ?h= hash is carried in the page URL).
    var vm = src.match(/player\.vimeo\.com\/video\/(\d+)(?:\?h=([a-zA-Z0-9]+))?/);
    if (vm) {
      var page = 'https://vimeo.com/' + vm[1] + (vm[2] ? '/' + vm[2] : '');
      fetch('https://vimeo.com/api/oembed.json?url=' + encodeURIComponent(page) + '&width=1280')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (d && d.thumbnail_url) insertThumb(host, btn, d.thumbnail_url);
        })
        .catch(function () {});
    }
  }

  function initThumbs(root) {
    (root || document).querySelectorAll('[data-mm-embed]').forEach(autoThumb);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initThumbs(); });
  } else {
    initThumbs();
  }
  // Theme editor re-renders sections in place - re-scan when that happens.
  document.addEventListener('shopify:section:load', function (e) { initThumbs(e.target); });
})();
